import { Button, useTheme } from "@mui/material";
import { Box } from "@mui/system";

const CustomButton = ({
  title,
  onClick,
  disabled,
  submit,
  fSize = "16px",
  width = "auto",
  height = "auto",
  bShadow = "4px",
  bRadius = "8px",
  bgColor,
  color = "black.main",
  mRight = "0px",
  mLeft = "0px",
  icon1,
  icon2,
  className,
  justify,
}) => {
  const theme = useTheme();

  return (
    <Button
      className={className ? className : ""}
      type={submit ? "submit" : "button"}
      onClick={onClick}
      disabled={disabled}
      variant='contained'
      sx={{
        fontSize: `${fSize}`,
        fontWeight: 600,
        width: width,
        height: height,
        padding: "0",
        border: "2px solid",
        borderColor: "black.main",
        color: `${bgColor === "primary.main" ? "#212121" : color}`,
        boxShadow: `0px ${bShadow} 0px ${theme.palette.black.main}`,
        pt: "4px",
        mr: mRight,
        ml: mLeft,
        px: "8px",
        borderRadius: `${bRadius}`,
        backgroundColor: `${bgColor}`,
        "&.Mui-disabled": {
          backgroundColor: "primaryDisabled.main",
          color: "blackDisabled.main",
          borderColor: "blackDisabled.main",
        },
        "&.MuiButtonBase-root:hover": {
          border: "2px solid",
          borderColor: `${bgColor === "white.main" ? "black.main" : bgColor}`,
          backgroundColor: `${bgColor}`,
          boxShadow: `0px ${bShadow} 0px ${theme.palette.black.main}`,
        },
        "&.MuiButtonBase-root:active": {
          border: "2px solid",
          borderColor: `black.main`,
          backgroundColor: "black.main",
          color: "white.main",
          boxShadow: "none",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: justify === "center" ? "center" : "space-around",
          width: "100%",
          alignItems: "center",
        }}
      >
        {icon1 && (
          <Box sx={{ display: "flex", mb: "2px", mr: "4px" }}> {icon1}</Box>
        )}
        <Box sx={{ fontWeight: 600 }}> {title}</Box>
        {icon2 && (
          <Box sx={{ display: "flex", alignItems: "center" }}> {icon2}</Box>
        )}
      </Box>
    </Button>
  );
};

export default CustomButton;
